import { Controller } from "@hotwired/stimulus";

// Polls a lazy-loaded audience count turbo-frame until the rendered cell
// reports `data-state="fresh"`. The controller is attached to the turbo-frame
// itself so that `this.element.reload()` re-fetches the frame's `src`.
//
// Stops polling on disconnect, or as soon as the inner cell renders fresh.
export default class extends Controller {
  static values = { pollMs: { type: Number, default: 2000 } };

  connect() {
    this.boundOnFrameLoad = this.onFrameLoad.bind(this);
    this.element.addEventListener("turbo:frame-load", this.boundOnFrameLoad);
    this.scheduleIfStale();
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.boundOnFrameLoad);
    this.clearTimer();
  }

  onFrameLoad() {
    this.scheduleIfStale();
  }

  scheduleIfStale() {
    this.clearTimer();
    const state = this.currentState();
    // Only re-arm on known non-fresh states. If the inner cell ever renders
    // without a `data-state`, treat that as "stop polling" rather than loop
    // forever.
    if (state !== "stale" && state !== "missing") return;
    this.timer = setTimeout(() => {
      this.timer = null;
      // `reload()` is provided by Turbo's HTMLFrameElement and re-fetches `src`.
      if (typeof this.element.reload === "function") {
        this.element.reload();
      }
    }, this.pollMsValue);
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  currentState() {
    const stateEl = this.element.querySelector("[data-state]");
    return stateEl ? stateEl.dataset.state : null;
  }
}
